<template>
  <BaseStyle :model="model" class="content-base">
    <div
      v-for="targetItem in purchaseItems"
      :key="targetItem.name"
      class="flex px-5 py-6 items-start"
    >
      <div class="w-7/12" v-text="targetItem.name" />
      <input
        v-model.number="targetItem.count"
        class="w-2/12 mx-5 p-1 text-center border rounded"
        type="number"
        min="0"
      />
      <div class="w-3/12 text-left" v-text="targetItem.itemUnit" />
    </div>
  </BaseStyle>
</template>

<script lang="ts">
import { defineComponent, onMounted, PropType } from 'vue';

import { useInsertDataStore } from '@/hooks/use_insert_data_store';
import { campaign } from '@/json/json_loader';
import { ContentPurchaseCountDeclareModel } from '@/models/content_purchase_count_declare_model';

import BaseStyle from './BaseStyle.vue';

export default defineComponent({
  name: 'ContentPurchaseCountConfirm',
  components: {
    BaseStyle,
  },
  props: {

    /**
     * Model
     */
    model: {
      type: Object as PropType<ContentPurchaseCountDeclareModel>,
      default: undefined,
    },
  },
  setup() {
    const { purchaseItems } = useInsertDataStore();
    onMounted(() => {
      purchaseItems.value ??= campaign.targetItems;
    });

    return {
      purchaseItems,
    };
  },
});
</script>
